export default __webpack_public_path__ + "media/icons/speaker-icon-cd0ae44d.png";